import Home from '../games/Home.vue';
import Findthenumber from '../games/Findthenumber/Findthenumber.vue';
import Dotsandboxes from '../games/Dotsandboxes/Dotsandboxes.vue';
import Trueorfalse from '../games/Trueorfalse/Trueorfalse.vue';
import Tictactoe from '../games/Tictactoe/Tictactoe.vue';

const routes = [
   { path: '*', redirect: '/' },
   {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/findthenumber',
    name: 'Findthenumber',
    component: Findthenumber,
  },
  {
    path: '/dotsandboxes',
    name: 'Dotsandboxes',
    component: Dotsandboxes,
  },
  {
    path: '/trueorfalse',
    name: 'Trueorfalse',
    component: Trueorfalse,
  },
  {
    path: '/tictactoe',
    name: 'Tictactoe',
    component: Tictactoe,
  },
];

export default routes;
